import { reactive, readonly } from "vue";
import gsap from 'gsap';

const state = reactive({
	isLoading: false,
	firstVisit: true,
	showIntro: false,
	showHotspots: false,
	activeLang: 'en',
  availableLangs: [],
	availableLocales: [], // for i18n
	activeContent: [],
  hostspotClikced: false
});

export default {
  state: readonly(state),
  actions: {
		toggleIntro(val) {
			console.log('toggle intro', val);
			if(!val) state.firstVisit = false;
			state.showIntro = val;
		},
		toggleLoading(val) {
			console.log('toggleLoading', val);
			state.isLoading = val
		},
    setHotspotState(val) {
      state.hostspotClikced = val;
    },
		showHotspots(val) {
			console.log('showHotspots', val);
			state.showHotspots = val
		},
		setActiveLang(lang) {
			console.log('setActiveLang', lang);
			state.activeLang = lang
		},
    setAvailableLangs(items) {
      state.availableLangs = items;
			items.map(function(value) {
				state.availableLocales.push(value.lang);
			});
    },
    setActiveContent(content) {
			console.log('setActiveContent', content);
      state.activeContent = content;
    },
    beforeEnterOverlayBg(el) {
      if(state.hostspotClikced) {
        gsap.set(el, {opacity: 0});
      }
    },
    enterOverlayBg(el, done) {
      if(state.hostspotClikced) {
        gsap.to(el, 0.24, {opacity: 1, onComplete: done});
      }
    },
    leaveOverlayBg(el, done) {
      if(state.hostspotClikced) {
        let that = this;
        gsap.to(el, 0.4, {
          opacity: 0, onComplete: function () {
            that.actions.toggleIntro(false);
            that.actions.showHotspots(true);
            done();
          }
        });
      }
    },
    leaveVideoOverlayBg(el, done) {
      // if(state.hostspotClikced) {
        gsap.to(el, 0.4, {opacity: 0, onComplete: done});
      // }
    },
    beforeEnterOverlay(el) {
      if(state.hostspotClikced) {
        gsap.set(el, {opacity: 0, scale: 0.5}).delay(0.5);
      }
    },
    enterOverlay(el, done) {
      if(state.hostspotClikced) {
        gsap.to(el, 0.4, {opacity: 1, scale: 1, onComplete: done}).delay(0.5);
      }
    },
    leaveOverlay(el, done) {
      if(state.hostspotClikced) {
        gsap.to(el, 0.4, {opacity: 0, onComplete: done});
      }
    },
    beforeEnterModal(el) {
      if(state.hostspotClikced) {
        gsap.set(el, { opacity: 0, scale: 0.5});
        setTimeout(() => {
          state.hostspotClikced = false;
        }, 200)
      }
    },
    enterModal(el, done) {
      if(state.hostspotClikced) {
        gsap.to(el, 0.4, {opacity: 1, scale: 1, onComplete: done}).delay(0.5);
      }
    },
    leaveModal(el, done) {
      if(state.hostspotClikced) {
        gsap.to(el, 0.4, {opacity: 0, scale: 0.5, onComplete: done}).delay(0.5);
      }
    },
    beforeEnterProduct(el) {
      // if(state.hostspotClikced) {
        gsap.set(el, {opacity: 0, y: 100}).delay(0.5);
      // }
    },
    enterProduct(el, done) {
      // if(state.hostspotClikced) {
        gsap.to(el, 0.6, {opacity: 1, y: 0, onComplete: done}).delay(0.5);
      // }
    },
    leaveProduct(el, done) {
      // if(state.hostspotClikced) {
        gsap.to(el, 0.4, {opacity: 0, onComplete: done});
      // }
    },
    beforeArrow(el) {
      gsap.set(el, {opacity: 0, scale: 1.5});
    },
    clickArrow(el, done) {
      gsap.to(el, 0.25, {opacity: 1, scale: 0.5, onComplete: done});
      gsap.to(el, 0.25, {opacity: 1, scale: 1, onComplete: done});
    },
    leaveArrow(el, done) {
      gsap.to(el, 0.4, {opacity: 0, scale: 2, onComplete: done});
    },
    beforeVideoModal(el) {
      gsap.set(el, { opacity: 0, scale: 0.5});
      setTimeout(() => {
        state.hostspotClikced = false;
      }, 200)
    },
    enterVideoModal(el, done) {
      gsap.to(el, 0.4, {opacity: 1, scale: 1, onComplete: done}).delay(0.5);
  },
  leaveVideoModal(el, done) {
    gsap.to(el, 0.4, {opacity: 0, scale: 0, onComplete: done}).delay(0.5);
  },

  }
};
